/**
 * Created by alvinoktavianus on 6/19/17.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { Field, getFormValues, reduxForm, change } from 'redux-form'
import { currencyFormatter } from 'utils/formatter'
import _ from 'lodash'
import moment from 'moment'

import styles from './AddOutletModal.css'
import { hideAddOutletModal, verifyAddOutletBilling } from 'actions/outletPages/list'
import * as mpOutlet from 'mixpanel/outlets/list'

class AddOutletModal extends Component {
  render () {
    let {showAddOutletModal, outletPrice, payButtonMessage, outletCount, disablePayButton, pendingPaymentMessage, onLoadingPayButton, usedOutletSlots} = this.props

    return (
      <Modal
        onHide={() => this._hideModal()} show={showAddOutletModal}
        dialogClassName={`${styles['add-outlet-modal-wrapper']} modal-dialog`}>
        <Modal.Body bsClass={styles['modal-wrapper']}>
          <div className='add-outlet-modal-wrapper'>
            <button type='button' className='close' onClick={() => { this._hideModal() }}>
              <span aria-hidden='true'>&times;</span>
            </button>
            <h4>Add Outlet</h4>
            <hr />
            <div className='row' style={{verticalAlign: 'middle'}}>
              <div className='col-xs-4'>
                <span style={{lineHeight: '34px'}}>Number of Outlets</span>
              </div>
              <div className={`col-sm-2 col-xs-4`}>
                <div className={`input-group ${styles['spinner']}`}>
                  <Field id='count-outlet'
                    type='text' name='countOutlet' component='input'
                    className={`form-control ${styles['add-outlet-value']}`}
                    onChange={(e) => {
                      let value = e.target.value
                      if (!isNaN(value) && value > 0 && value < (10000 - usedOutletSlots)) {
                        this.props.dispatch(change('AddOutletModalForm', 'countOutlet', value))
                      } else if (value >= (9999 - usedOutletSlots)) {
                        this.props.dispatch(change('AddOutletModalForm', 'countOutlet', (9999 - usedOutletSlots)))
                      }
                      e.preventDefault()
                    }}
                  />
                  <div className={styles['input-group-btn-vertical']}>
                    <button className='btn btn-default' type='button' onClick={() => { this._upButton() }}>
                      <i className='fa fa-caret-up' />
                    </button>
                    <button className='btn btn-default' type='button' onClick={() => this._downButton()}>
                      <i className='fa fa-caret-down' />
                    </button>
                  </div>
                </div>
              </div>
              <div className='col-xs-1'>
                <strong>
                  <span className={styles['times-text']}>*</span>
                </strong>
              </div>
              <div className='col-xs-5'>
                {
                  outletPrice['MOKA'] && <div>
                    <div>
                      <span className={styles['pricing-text']}>{currencyFormatter(outletPrice['MOKA'].final_price)}</span>
                    </div>
                    <div>
                      <span className={styles['pro-rated-period-text']}>pro-rated for period from {moment().format('DD/MM/YYYY')} - {moment(outletPrice['MOKA'].end_date).format('DD/MM/YYYY')}</span>
                    </div>
                  </div>
                }
              </div>
            </div>
            {
              outletPrice && _.map(outletPrice, (featureDetail, featureName) => {
                if (featureName !== 'MOKA' && featureName !== 'final_price' && featureDetail.total_price !== 0) {
                  return (
                    <div className={`row ${styles['outlet-features']}`} style={{verticalAlign: 'middle'}}>
                      <div className='col-xs-4'>
                        <span style={{lineHeight: '34px'}}>{featureName}</span>
                      </div>
                      <div className='col-sm-2 col-xs-4' />
                      <div className='col-xs-1' />
                      <div className='col-xs-5'>
                        <div>
                          <span className={styles['pricing-text']}>{currencyFormatter(outletPrice[featureName].final_price)}</span>
                        </div>
                        <div>
                          <span className={styles['pro-rated-period-text']}>pro-rated for period from {moment().format('DD/MM/YYYY')} - {moment(outletPrice[featureName].end_date).format('DD/MM/YYYY')}</span>
                        </div>
                      </div>
                    </div>
                  )
                }
              })
            }
            <hr />
            <div className='row text-primary'>
              <div className='col-xs-7'>
                <h3>Total Payment</h3>
              </div>
              <div className='col-xs-5'>
                {
                  outletCount && outletPrice && <h3 className='totalCount'>{currencyFormatter((outletPrice['final_price'] * parseInt(outletCount.countOutlet)).toString())}</h3>
                }
              </div>
            </div>
            <hr />
            <div className={`row ${styles['pay-button-wrapper']}`}>
              <div className='col-xs-12'>
                <button id='pay-outlet-button' className={`btn btn-block btn-lg ${disablePayButton ? 'btn-disabled' : 'btn-primary'} ${onLoadingPayButton ? styles['on-loading-button'] : ''}`} onClick={() => this._payOutlet()} disabled={disablePayButton}>{payButtonMessage}</button>
              </div>
            </div>
            {
              pendingPaymentMessage && <div className={`row ${styles['pending-message']} ${styles['text-xs']}`}>
                <div className='col-md-12'>
                  <em>{pendingPaymentMessage}</em>
                </div>
              </div>
            }
          </div>
        </Modal.Body>
      </Modal>
    )
  }

  _hideModal = () => {
    this.props.dispatch(hideAddOutletModal())
  }

  _upButton = () => {
    const {outletCount: {countOutlet}, usedOutletSlots} = this.props
    let value = countOutlet

    value++
    if (!isNaN(value) && value < (10000 - usedOutletSlots)) {
      this.props.dispatch(change('AddOutletModalForm', 'countOutlet', value))
    }
  }

  _downButton = () => {
    const {outletCount: {countOutlet}} = this.props
    let value = countOutlet

    value--
    if (!isNaN(value) && value > 0) {
      this.props.dispatch(change('AddOutletModalForm', 'countOutlet', value))
    }
  }

  _payOutlet = () => {
    const {outletCount: {countOutlet}, outletPrice} = this.props
    let billingData = {
      type: 'OutletBilling',
      total_amount: (outletPrice['final_price'] * parseInt(countOutlet)),
      add_outlet_count: parseInt(countOutlet)
    }
    mpOutlet.outletPay({billingData})
    this.props.dispatch(verifyAddOutletBilling(billingData))
  }
}

const mapForm = {
  form: 'AddOutletModalForm'
}

function mapStateToProps (state) {
  let {showAddOutletModal, outletPrice, payButtonMessage, disablePayButton, pendingPaymentMessage, onLoadingPayButton, usedOutletSlots} = state.outletPages.list
  return {
    showAddOutletModal,
    outletCount: getFormValues('AddOutletModalForm')(state),
    outletPrice,
    payButtonMessage,
    disablePayButton,
    pendingPaymentMessage,
    onLoadingPayButton,
    usedOutletSlots
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(AddOutletModal))



// WEBPACK FOOTER //
// ./app/pages/Outlets/List/AddOutletModal/AddOutletModal.js